import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const WhoWeAre = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Label */}
        <p className="text-xs font-semibold text-[#666666] uppercase tracking-wider mb-2">WHO WE ARE</p>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-[#333333] mb-6 leading-tight">
              Empowering Businesses
              <br />
              with the Right Funding
            </h2>
            
            <p className="text-[#666666] mb-6 leading-relaxed">
              At Funding Sathi, we believe every business deserves the right financial support to grow and succeed. Our mission is to provide fast, hassle-free and flexible funding solutions that help businesses unlock their true potential.
            </p>

            <Link to="/about">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="inline-flex items-center gap-2 bg-[#5C1F33] text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#800020] transition-all"
              >
                Learn More About Us
                <ArrowRight className="w-4 h-4" />
              </motion.button>
            </Link>
          </motion.div>

          {/* Right Content - Image with Badge */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="/img.png" 
                alt="Business handshake"
                className="w-full h-64 sm:h-80 lg:h-[28rem] object-cover"
              />
              
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
